<section id="homepage-default">
    <fitscovery-ui-default-banner [partner]="partner"></fitscovery-ui-default-banner>
    <!-- 1st Section -->
    <fitscovery-ui-default-section-odd [partner]="partner" [imageDescription]="(imageDescriptions | imageDescription: 2)!"></fitscovery-ui-default-section-odd>
    <!-- 2nd Section -->
    <fitscovery-ui-default-section-even [partner]="partner" [imageDescription]="(imageDescriptions | imageDescription: 3)!"></fitscovery-ui-default-section-even>
    <!-- 3rd Section -->
    <fitscovery-ui-default-section-odd [partner]="partner" [imageDescription]="(imageDescriptions | imageDescription: 4)!"></fitscovery-ui-default-section-odd>
    <fitscovery-ui-default-section-last [partner]="partner"></fitscovery-ui-default-section-last>
</section>